module.exports = __webpack_public_path__ + "static/innovation_card_img2@2x-8c38f5fcb7aec8ac1e6c5c726ab9ee66.jpg";